import React from 'react';
import './Feedback.scss';
import { join } from "@/fetch";
class Feedback extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      bannerImages: [
        { imgPath: require("img/Feedbackbg.png"), imgHDPath: `${require("img/Feedbackbg.png")} 1x,${require("img/Feedbackbg@2x.png")} 2x,${require("img/Feedbackbg@3x.png")} 3x`, attachURL: "/" },
      ],
      goRight: [
        { imgPath: require("img/go.png"), imgHDPath: `${require("img/go.png")} 1x,${require("img/go@2x.png")} 2x,${require("img/go@3x.png")} 3x`, attachURL: "/" },
      ],
      typologyArr: [{ ids: 0, name: '建议' }, { ids: 1, name: '投诉' }, { ids: 2, name: '其他' }],
      FeedbackprojectName: '',//项目名称
      FeedbackTitle: '',//标题
      FeedbackContent: '',//内容
      FeedbackName: '',//姓名
      FeedbackEmail: '',//邮箱
      FeedbackCompany: '',//公司
      FeedbackTel: '',//电话
      FeedbackContentNum: 0,
      currentIndex: "",
      toastName: '信息不完整,请重新填写~',
      isShow: 0
    }
  }
  changeType() {
    let mask = document.querySelector('.mask');
    mask.style.display = "block";
    mask.classList.add("coverAniamtion");
  }
  FeedbackTitleFn(e) {
    this.setState({
      FeedbackTitle: e.target.value
    })
  }
  FeedbackContentFn(e) {
    let getValue = e.target.value;
    let len = getValue.length;
    this.setState({ FeedbackContent: getValue, FeedbackContentNum: len });
  }
  FeedbackNameFn(e) {
    this.setState({
      FeedbackName: e.target.value
    })
  }
  FeedbackEmailFn(e) {
    this.setState({
      FeedbackEmail: e.target.value
    })
  }
  FeedbackCompanyFn(e) {
    this.setState({
      FeedbackCompany: e.target.value
    })
  }
  FeedbackTelFn(e) {
    this.setState({
      FeedbackTel: e.target.value
    })
  }
  FeedbackprojectNameFn(e) {
    this.setState({
      FeedbackprojectName: e.target.value
    })
  }
  //点击提交按钮
  submitFn() {
    const { FeedbackprojectName, FeedbackTitle, FeedbackContent, FeedbackName, FeedbackEmail, FeedbackCompany, FeedbackTel, currentIndex } = this.state
    if (FeedbackTitle && FeedbackContent && FeedbackName && FeedbackEmail) {
      if (!(/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(FeedbackEmail))) {
        this.changeTitle('请输入正确的邮箱！')
      }
      else if (FeedbackTel && !(/^[1][3-9]\d{9}$/.test(FeedbackTel))) {
        this.changeTitle('请输入正确的电话！')
      }
      else {
        let data = {
          type: currentIndex,     //类型
          title: FeedbackTitle,       //标题
          content: FeedbackContent,     //内容
          name: FeedbackName,    //姓名
          email: FeedbackEmail,     //邮箱
          company: FeedbackCompany,     //公司
          tel: FeedbackTel,       //电话
          projectName: FeedbackprojectName//项目名称
        }
        if (data.type !== '投诉') {
          data.projectName = ''
        }
        join.addOrUpdateFeedback(data).then(res => {
          if (res.errorCode === "200") {
            // this.props.history.go(0)//强制刷新当前路由
            this.changeTitle('提交成功！')
            this.setState({
              FeedbackprojectName: '',//项目名称
              FeedbackTitle: '',//标题
              FeedbackContent: '',//内容
              FeedbackName: '',//姓名
              FeedbackEmail: '',//邮箱
              FeedbackCompany: '',//公司
              FeedbackTel: '',//电话
              FeedbackContentNum: 0,
              currentIndex: "建议",
              isShow: 0,
            })
          } else {
            this.changeTitle(res.errorMsg)
          }
        }).catch(err => {
          this.changeTitle(err.errorMsg)
          console.log(err);
        })
      }
    } else {
      this.changeTitle('信息不完整,请重新填写~')
    }
  }
  changeTitle(title) {
    let toast = document.querySelector('.toast');
    toast.style.display = 'block';
    toast.classList.add("Aniamtioncover");
    setTimeout(function () {
      toast.style.display = 'none';
    }, 2000);
    this.setState({
      toastName: title
    })
  }
  dropdownChanged(e) {
    this.setState({
      currentIndex: e.target.value,
    })
    if (e.target.value === '投诉') {
      this.setState({
        isShow: 1,
      })
    } else {
      this.setState({
        isShow: 0,
      })
    }
  }
  render() {
    const { FeedbackprojectName, FeedbackTitle, FeedbackContent, FeedbackName, FeedbackEmail, FeedbackCompany, FeedbackTel, FeedbackContentNum, toastName, isShow } = this.state
    return (
      <div className='Feedback'>
        <main className="Feedback-body">
          <section className="swiper-container">
            <div className="swiper-wrapper">
              {
                this.state.bannerImages.map((item, index) =>
                  item.attachURL && item.attachURL !== '/' ?
                    <a className="swiper-slide"
                      key={index}
                      href={item.attachURL}>
                      <img src={item.imgPath} alt="" srcSet={item.imgHDPath} width="100%" height="100%" />
                    </a>
                    :
                    <img key={index} src={item.imgPath} alt="" srcSet={item.imgHDPath} width="100%" height="100%" />
                )
              }
            </div>
            <div className="swiper-pagination"></div>
            <h5>投诉和建议</h5>
            <p>感谢您的关注！欢迎提交任何关于我们的问题和建议，我</p>
            <p>们将尽快回复您。</p>
          </section>
          <div className='Feedback-contion'>
            <h4>在线提交问题/建议</h4>
            <div className='Feedback-contion-massgae'>
              <p><i></i><span>反馈信息</span></p>
              <form style={{ padding: "12px 15px" }}>
                <span>类型</span>
                <span>
                  <select id="selectTravelCity" value={this.state.currentIndex} onChange={this.dropdownChanged.bind(this)}>
                    <option value='建议'>建议</option>
                    <option value='投诉'>投诉</option>
                    <option value='其他'>其他</option>
                  </select>
                  {
                    this.state.goRight.map((item, index) =>
                      <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} />
                    )
                  }
                </span>
              </form>
              <form style={{ margin: "0 15px", display: isShow === 0 ? "none" : "block" }}>
                <span>项目名称</span>
                <input type="text" placeholder='请输入' value={FeedbackprojectName} onChange={this.FeedbackprojectNameFn.bind(this)} />
              </form>
              <form style={{ margin: "0 15px" }}>
                <span>标题<i>*</i></span>
                <input type="text" placeholder='请输入' value={FeedbackTitle} onChange={this.FeedbackTitleFn.bind(this)} />
              </form>
              <form className='textare' style={{ margin: "0 15px" }}>
                <span>内容<i>*</i></span>
                <span>
                  <textarea rows="1" style={{ height: "80px", width: "100%", fontSize: '16px' }} disabled={FeedbackContentNum === 1000 ? "disabled" : ''} value={FeedbackContent} onChange={this.FeedbackContentFn.bind(this)}></textarea>
                  <p>{FeedbackContentNum === 0 ? 0 : FeedbackContentNum}/1000</p>
                </span>
              </form>
            </div>
            <div className='Feedback-contion-massgae Feedback-contion-user'>
              <p><i></i><span>用户信息</span></p>
              <form style={{ padding: "12px 15px" }}>
                <span>姓名<i>*</i></span>
                <input type="text" placeholder='请输入您的姓名' value={FeedbackName} onChange={this.FeedbackNameFn.bind(this)} />
              </form>
              <form style={{ margin: "0 15px" }}>
                <span>邮箱<i>*</i></span>
                <input type="text" placeholder='请输入' value={FeedbackEmail} onChange={this.FeedbackEmailFn.bind(this)} />
              </form>
              <form style={{ margin: "0 15px" }}>
                <span>公司</span>
                <input type="text" placeholder='请输入' value={FeedbackCompany} onChange={this.FeedbackCompanyFn.bind(this)} />
              </form>
              <form style={{ margin: "0 15px" }}>
                <span>电话</span>
                <input type="text" placeholder='请输入' value={FeedbackTel} onChange={this.FeedbackTelFn.bind(this)} />
              </form>
            </div>
          </div>
          <div className='submit'>
            <button onClick={this.submitFn.bind(this)}>提交</button>
          </div>
        </main>
        <div className='toast'>{toastName}</div>
      </div>
    );
  }
}

export default Feedback;
